import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import PropTypes from "prop-types";
import { CompoundDetailsTable } from "./CompoundDetailTable";

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

export default function DetailsDialog({ open, setOpen, modalData }) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          style={{ cursor: "move", backgroundColor: "whitesmoke" }}
          id="draggable-dialog-title"
        >
          Detalles del componente
        </DialogTitle>
        <DialogContent>
          <CompoundDetailsTable data={modalData} />
        </DialogContent>
        <DialogActions style={{ cursor: "move", backgroundColor: "whitesmoke" }}>
          <Button autoFocus onClick={handleClose}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

DetailsDialog.defaultProps = {
  open: false,
  setOpen: null,
  modalData: [],
};

DetailsDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  modalData: PropTypes.array,
};
